/**
 * wugaoliang
 * vuex types
 */

export const LOGIN = 'login';

export const LOGOUT = 'logout';

export const TITLE = 'title';



// WEBPACK FOOTER //
// ./src/store/types.js